import { PilotId } from '~/eds/src/types/PilotId';
import { DocumentHandler } from '~/features/document-handler/types/document-handler';
import { pilot } from '~/services/serviceInstances';

import { DocumentServerResponse } from '../document';
import { mapResponse } from './mapper';

export const getDocumentHandler = async (
  id: PilotId,
): Promise<DocumentHandler> => {
  const docHandler: DocumentServerResponse = await pilot.get(`document/${id}/`);
  return mapResponse(docHandler);
};
